export enum Features {
  VOICEOVER_TRANSLATIONS = 'VOICEOVER_TRANSLATIONS',
  ASK_AI_FEED = 'ASK_AI_FEED',
  REQUIRE_CORRECT_ANSWER = 'REQUIRE_CORRECT_ANSWER',
  INTERCOM_UPDATE = 'INTERCOM_UPDATE',
}
